import React from "react";
function importAll(r) {
  return r.keys().map(r);
}

// auto import all images from folder
const images = importAll(
  require.context("../assets/gallery3", false, /\.(png|jpe?g|webp)$/)
);

function Gallery3() {
  return (
    <>

      <div className="gallery-page">
        <h2 className="gallery-heading">Gallery</h2>

        <div className="gallery-grid">
          {images.map((img, index) => (
            <img key={index} src={img} alt="gallery" />
          ))}
        </div>
      </div>

    </>
  );
}

export default Gallery3;
